export default [
  {value: 'Male', id: 1},
  {value: 'Female', id: 2},
]